
<div class="faqs-content">
    <div class="accordion" id="accordionFaqs">
        <template v-if="faqs.length > 0">
            <b-card no-body class="mb-3" v-for="(faq, index) in faqs" :key="faq['id']">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <h6 class="header-tab" v-b-toggle="'accordion-'+index">
                        <img :src="`/public-assets/arrow-right`" class="faq-arrow" width="10" height="19"/> <span v-if="faq['pregunta']">{{faq['pregunta']}}</span>
                    </h6>
                </b-card-header>
                <b-collapse :id="'accordion-'+index" visible accordion="accordion-tabs" role="tabpanel">
                    <b-card-body>
                        <div class="dcard-body" v-if="faq['respuestas']" v-html="faq['respuestas']"></div>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </template>
    </div>
    <div class="col-12 text-center" v-if="faqs.length == 0 && !status['isLoading']">
        <br>
        <h2 class="title">Por el momento no hay preguntas frecuentes que mostrar.</h2>
    </div>
    <div class="col-12 text-center" v-if="status['isLoading']">
        <div class="spinner-border text-warning" role="status">
            <span class="sr-only"></span>
        </div>
        <label class="col-12">Cargando contenido</label>
    </div>
</div>
